'use strict'

module.exports = {
  br: require('./br'),
  ca: require('./ca'),
  fi: require('./fi'),
  jp: require('./jp'),
  us: require('./us')
}
